// Recovered compiled webpack factory 65360. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return "(" === e[0] && e.endsWith(")");
  }
  function n(e) {
    return e.startsWith("@") && "@children" !== e;
  }
  function a(e, t) {
    if (e.includes(o)) {
      let e = JSON.stringify(t);
      return "{}" !== e ? o + "?" + e : o;
    }
    return e;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      DEFAULT_SEGMENT_KEY: function () {
        return i;
      },
      PAGE_SEGMENT_KEY: function () {
        return o;
      },
      addSearchParamsIfPageSegment: function () {
        return a;
      },
      isGroupSegment: function () {
        return r;
      },
      isParallelRouteSegment: function () {
        return n;
      },
    }));
  let o = "__PAGE__",
    i = "__DEFAULT__";
}
